var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 717,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 507,
	"./assets/thewest-digital-hero-variation-a.jpg": 718,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 719,
	"./assets/thewest-digital-hero-variation-b.jpg": 2624,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 720,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2625,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 721,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2626,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 722,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2627,
	"./assets/thewest-digital-hero.jpg": 2628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2623;